export default {
  title: 'dark',

  colors: {
    primary: '#04ccd3',
    secondary: '#9898a3',

    background: '#121214',
    backgroundItem: '#202024',
    backgroundInput: '#edeff0',

    title: '#a8a8b3',
    titleCard: '#dadae0',
    description: '#87868b',
  },
};
